import React, { useEffect, useState } from "react";
import "./index.css";
import { getAPIUrlBM } from "../../../utils/config";
import GET from "../../../Apis/backlink/Get";
import TipLoader from "../../utils/TipLoader/TipLoader";
import { useLocation } from "react-router-dom";

export const getAllUserAccounts = async () => {
  const response = await GET(getAPIUrlBM() + "/get-all-user-accounts", {});
  return response;
};
export const getAllUserSites = async (filter) => {
  const url = getAPIUrlBM();
  const urlWithParams = makeUrlWithParams(url + "/get-all-user-sites", filter);
  const response = await GET(urlWithParams, {});
  return response;
};
export const URLCleaning = (url) => {
  let sitename = "";
  if (url?.startsWith("sc-domain:")) {
    // eslint-disable-next-line prefer-destructuring
    sitename = url?.split(":")[1];
  } else {
    // eslint-disable-next-line prefer-destructuring
    sitename = url?.split("://")[1];
  }
  return sitename;
};
export const datetime = (data) => {
  const inputDatetime = new Date(data);

  // Format the Date object as per your desired format
  const options = {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  const outputDatetimeStr = inputDatetime.toLocaleString("en-US", options);
  return outputDatetimeStr;
};
export const makeUrlWithParams = (url, params) => {
  let urlWithParams = url;
  if (params) {
    urlWithParams += "?";
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        urlWithParams += `${key}=${params[key]}&`;
      }
    }
    urlWithParams = urlWithParams.slice(0, -1);
  }
  return urlWithParams;
};
const ActivityLogs = ({ product }) => {
  const [activityLogs, setActivityLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allAccouts, setAllAccouts] = useState([]);
  const [allSites, setAllSites] = useState([]);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [sitesThatAreRelatedToAccount, setSitesThatAreRelatedToAccount] =
    useState([]);
  const [filter, setFilter] = useState({
    account: null,
    site: null,
    search: "",
  });

  const { state: getParams } = useLocation();

  console.log(getParams);

  useEffect(() => {
    if (getParams?.siteId || getParams?.accountId) {
      // setFilter({ ...filter, ...getParams });
      const { siteId, accountId } = getParams;
      if (accountId) {
        handleSitesFilterBasedOnAccount({ target: { value: accountId } });
      }
      if (siteId && accountId) {
        setFilter({ ...filter, site: siteId, account: accountId });
      } else if (siteId) {
        setFilter({ ...filter, site: siteId });
      } else if (accountId) {
        setFilter({ ...filter, account: accountId });
      }
    }
  }, [getParams]);

  const getActivityLogs = async () => {
    try {
      setLoading(true);
      const url = getAPIUrlBM();

      const urlWithParams = makeUrlWithParams(url + "/get-activity-logs", {
        accountId: filter.account,
        siteId: filter.site,
        search: filter.search,
        page,
      });
      // get-count-of-activity-logs
      const urkWithParamsForTotal = makeUrlWithParams(
        url + "/get-count-of-activity-logs",
        {
          accountId: filter.account,
          siteId: filter.site,
          search: filter.search,
        },
      );
      const responseForTotal = await GET(urkWithParamsForTotal);
      const response = await GET(urlWithParams);
      // const jsonData = await response;
      // console.log(jsonData);
      if (response.status === 200) {
        setActivityLogs(response.data);
      } else {
        setActivityLogs([]);
      }
      if (responseForTotal.status === 200) {
        setTotal(responseForTotal.data[0]?.count || 0);
      } else {
        setTotal(0);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      setActivityLogs([]);
      console.error(err.message);
    }
  };

  const getAccounts = async () => {
    try {
      const response = await getAllUserAccounts();
      if (response.status === 200) {
        setAllAccouts(response.data);
      } else {
        setAllAccouts([]);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleSitesFilterBasedOnAccount = (e) => {
    const selectedAccount = e.target.value;
    if (selectedAccount === "novalue") {
      setSitesThatAreRelatedToAccount([]);
      setPage(1);
      setFilter({ ...filter, account: null });
      return;
    }
    const sites = allSites.filter(
      (site) => site.account_id === selectedAccount,
    );
    setSitesThatAreRelatedToAccount(sites);
    setPage(1);
    setFilter({ ...filter, account: selectedAccount });
  };

  useEffect(() => {
    if (search === null) {
      return;
    }
    const totalTime = setTimeout(() => {
      setPage(1);
      setFilter({ ...filter, search: search });
    }, 1000);

    return () => clearTimeout(totalTime);
  }, [search]);

  const handleSiteFilter = (e) => {
    const selectedSite = e.target.value;
    if (selectedSite === "novalue") {
      setFilter({ ...filter, site: null });
      return;
    }
    setPage(1);
    setFilter({ ...filter, site: selectedSite });
  };
  const getSites = async () => {
    try {
      const response = await getAllUserSites(filter);
      if (response.status === 200) {
        setAllSites(response.data);
      } else {
        setAllSites([]);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getAccounts();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      getActivityLogs();
      getSites();
    }, 500);
    return () => clearTimeout(timer);
  }, [page, filter]);

  return (
    <div className="activity-container">
      <div className="activity-header">
        <h1>Activity Logs</h1>

        <span
          className="reload-button"
          onClick={() => {
            getActivityLogs();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="16"
            className="icon"
            viewBox="0 0 512 512"
            fill="#6b7280"
          >
            <path d="M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z" />
          </svg>
          Refresh Logs
          <span className="ripple"></span>
        </span>
      </div>

      <div
        className="activity-header"
        style={{
          marginTop: "-0.7rem",
        }}
      >
        <span
          className="how_it_works_for_indexmenow"
          onClick={() => {
            window.open(
              "https://app.supademo.com/demo/clscfbbsg0q50pewgaqrd4q4e",
              "_blank",
            );
          }}
        >
          How it Works?{" "}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.55 0.858814H8.21636L8.19298 0.858317C8.16961 0.856327 8.14648 0.853592 8.12335 0.848245C8.07014 0.836309 8.01916 0.813429 7.97464 0.781726C7.85852 0.69954 7.79137 0.559783 7.79921 0.417651C7.80144 0.378608 7.80928 0.33994 7.82208 0.303135C7.83763 0.258872 7.8605 0.217094 7.88972 0.180537C7.92404 0.13764 7.96631 0.101706 8.01419 0.0752234C8.05547 0.0527184 8.10023 0.0368041 8.14648 0.0289706C8.16712 0.0256135 8.17209 0.0256135 8.19298 0.0236241C9.31786 -0.00783315 10.4445 -0.00783314 11.5695 0.0233755H11.5743L11.5776 0.0236241H11.5821C11.5859 0.0241215 11.5899 0.0244945 11.5938 0.0247432L11.6055 0.0256135C11.6328 0.0298409 11.64 0.0300894 11.6668 0.0373012C11.6757 0.039788 11.6843 0.0422748 11.693 0.0451345L11.6966 0.0465022L11.7047 0.0496106L11.7119 0.0520974L11.7186 0.0548328L11.7228 0.0568222C11.7432 0.0654014 11.7624 0.0754728 11.781 0.0871602C11.8163 0.109417 11.8482 0.136771 11.8754 0.168477C11.8885 0.183771 11.9005 0.199935 11.9113 0.216968L11.9122 0.218335C11.9248 0.238105 11.9356 0.258992 11.9448 0.281003C11.9556 0.307487 11.9632 0.33422 11.9684 0.361823L11.9693 0.366051C11.9704 0.372765 11.9715 0.379106 11.9724 0.385572C11.9738 0.39614 11.9749 0.406709 11.976 0.41765C12.0075 1.53894 11.9765 2.66131 11.9765 3.78307C11.976 3.80396 11.9762 3.80931 11.974 3.82982C11.9687 3.87632 11.9554 3.92196 11.935 3.96436C11.9113 4.0136 11.8779 4.05823 11.8372 4.09441C11.808 4.12065 11.7751 4.14266 11.74 4.15932C11.6043 4.22472 11.4397 4.21079 11.3169 4.12363C11.2787 4.09665 11.245 4.06296 11.218 4.02478C11.1818 3.97381 11.1574 3.91475 11.1468 3.85295C11.1429 3.82983 11.1414 3.8067 11.1409 3.78307V1.4494L5.72693 6.86374C5.70654 6.88239 5.70181 6.88799 5.67955 6.9044C5.64586 6.92914 5.6088 6.94866 5.56927 6.96259C5.52028 6.97987 5.46793 6.9877 5.41584 6.98571C5.27906 6.98074 5.15038 6.90639 5.07777 6.79051C5.05551 6.75519 5.03872 6.71665 5.02791 6.67637C5.01709 6.63621 5.01237 6.59418 5.01398 6.55265C5.01672 6.47966 5.03872 6.4078 5.07777 6.346C5.09443 6.31927 5.11457 6.29589 5.13596 6.27277L10.5503 0.858744L10.55 0.858814Z"
              fill="#0048A1"
            />
            <path
              d="M5.47049 1.1387C5.50531 1.14367 5.51451 1.14367 5.54845 1.15375C5.62504 1.176 5.69442 1.22064 5.74652 1.2807C5.77276 1.31078 5.79439 1.34448 5.8108 1.38066C5.82746 1.41684 5.83865 1.45564 5.8445 1.4948C5.86153 1.61367 5.8256 1.73689 5.74677 1.82791C5.71195 1.86807 5.66968 1.90139 5.62256 1.92564C5.57543 1.94988 5.52371 1.96518 5.47074 1.97015C5.45769 1.97152 5.44426 1.97152 5.4312 1.97214C5.13827 1.97214 4.84521 1.97239 4.55227 1.9735C4.07905 1.97624 3.60557 1.97997 3.13296 2.00583C2.87036 2.02001 2.60737 2.0409 2.34725 2.0813C2.27676 2.09212 2.20638 2.10468 2.13638 2.11923C2.08876 2.1293 2.04138 2.14012 1.99439 2.15243C1.77655 2.20863 1.55621 2.29168 1.38525 2.44263C1.35292 2.47098 1.32283 2.50194 1.29473 2.53476C1.20956 2.63423 1.14652 2.75086 1.0984 2.8721C1.04021 3.01807 1.00117 3.1715 0.971699 3.32556C0.929673 3.54302 0.90518 3.76373 0.887896 3.98394C0.858055 4.35743 0.848108 4.73208 0.842264 5.10659C0.83729 5.44218 0.836172 5.77815 0.835799 6.11396C0.83555 6.41648 0.83555 6.71887 0.835799 7.02138C0.836047 7.44638 0.837788 7.87173 0.848356 8.2967C0.857806 8.66883 0.872851 9.04198 0.915251 9.41213C0.926442 9.50961 0.939746 9.6066 0.955908 9.7032C0.985998 9.88038 1.02579 10.0574 1.08932 10.2259C1.14167 10.3649 1.21154 10.4991 1.31077 10.6109C1.50573 10.831 1.79344 10.935 2.07247 10.9999C2.13041 11.0134 2.18884 11.0253 2.24741 11.0359C2.32151 11.0493 2.39612 11.0606 2.47072 11.0704C2.85144 11.1212 3.23662 11.1378 3.62008 11.1486C4.07268 11.1612 4.52575 11.1626 4.97873 11.1628C5.28012 11.1631 5.58176 11.1631 5.88341 11.1628C6.24883 11.1626 6.61401 11.1612 6.97933 11.1542C7.34525 11.1473 7.71156 11.1358 8.07637 11.1035C8.29085 11.0846 8.50557 11.0586 8.71644 11.0144C8.89474 10.9768 9.07266 10.9266 9.23591 10.8445C9.33253 10.796 9.42341 10.7353 9.50137 10.6599C9.69547 10.4721 9.7927 10.2086 9.8551 9.95127C9.86679 9.90278 9.87736 9.85379 9.88718 9.8048C9.90136 9.73293 9.91342 9.66057 9.92399 9.58783C9.93878 9.48587 9.95047 9.38342 9.96041 9.28096C9.99212 8.95321 10.0056 8.62335 10.0139 8.29384C10.0283 7.71867 10.0264 7.14298 10.0267 6.5673L10.0287 6.52776C10.0307 6.5147 10.0318 6.50127 10.0343 6.48822C10.0443 6.43612 10.0644 6.38626 10.0933 6.3415C10.1147 6.30805 10.141 6.27771 10.171 6.25185C10.2621 6.17302 10.3853 6.13709 10.5041 6.15412C10.5437 6.15997 10.5821 6.17116 10.6183 6.18782C10.6665 6.20983 10.7104 6.24104 10.747 6.27945C10.8022 6.3374 10.8397 6.41063 10.8548 6.48884C10.8615 6.52365 10.8606 6.5326 10.8622 6.56792C10.862 6.86148 10.862 7.15503 10.8606 7.4486C10.859 7.73744 10.8564 8.02626 10.8492 8.31512C10.8442 8.51232 10.8372 8.70953 10.8261 8.90646C10.8177 9.05853 10.8068 9.21035 10.7921 9.3618C10.7832 9.45505 10.7726 9.54818 10.76 9.64118C10.7511 9.7072 10.7414 9.77323 10.7302 9.83888C10.6603 10.251 10.5413 10.667 10.2962 11.0111C10.2592 11.0635 10.2194 11.1136 10.177 11.1616C10.1107 11.2366 10.0378 11.3062 9.95979 11.3688C9.84478 11.4614 9.71858 11.5393 9.58604 11.604C9.288 11.7491 8.96099 11.8273 8.63485 11.8783C8.39948 11.9151 8.16189 11.9376 7.9244 11.9535C7.67572 11.9705 7.42619 11.9797 7.1769 11.9858C6.81842 11.995 6.45972 11.9972 6.10125 11.9984C5.72661 11.9995 5.35238 11.9992 4.97774 11.9986C4.54717 11.9984 4.11634 11.997 3.68574 11.9863C3.28936 11.9766 2.89221 11.9604 2.49818 11.9158C2.40791 11.9055 2.31764 11.8938 2.228 11.8799C1.79431 11.8125 1.35317 11.6952 0.99059 11.4381C0.938493 11.4013 0.888134 11.3615 0.84014 11.3195C0.771632 11.2591 0.708095 11.1937 0.649655 11.1234C0.608746 11.0744 0.570575 11.0228 0.53489 10.9697C0.310088 10.6344 0.199048 10.237 0.132172 9.84286C0.117376 9.75433 0.104569 9.66568 0.0935047 9.57665C0.0818169 9.48228 0.0721185 9.38729 0.0636637 9.29254C0.0497379 9.13824 0.0396664 8.98394 0.0322063 8.82938C0.0205185 8.59823 0.0138046 8.3671 0.00932825 8.13583C0.0037331 7.83692 0.00186788 7.53837 0.000997641 7.23961C-0.000370047 6.86411 -0.000121388 6.48873 0.000500291 6.11323C0.000748982 5.71162 0.00211704 5.31002 0.0105721 4.90838C0.015297 4.6811 0.0225085 4.45356 0.0348179 4.22651C0.0428999 4.07445 0.0534686 3.92263 0.068017 3.77118C0.0788342 3.6553 0.0922627 3.53979 0.108674 3.42464C0.117875 3.35949 0.128195 3.29459 0.139883 3.22968C0.210008 2.83976 0.327631 2.44786 0.559025 2.12122C0.596079 2.06912 0.635615 2.01902 0.677892 1.97115C0.744163 1.89592 0.816902 1.82654 0.895109 1.76363C1.01708 1.66528 1.15187 1.58371 1.29363 1.51682C1.56518 1.38925 1.8596 1.31539 2.15454 1.26615C2.36144 1.23159 2.57009 1.20883 2.77896 1.19205C2.99145 1.17502 3.20456 1.16445 3.41792 1.15699C3.72653 1.14617 4.03537 1.14169 4.34425 1.13945C4.70657 1.13635 5.0689 1.13697 5.43097 1.13672C5.4444 1.13722 5.45745 1.13784 5.47076 1.13871L5.47049 1.1387Z"
              fill="#0048A1"
            />
          </svg>
        </span>
      </div>

      <div className="filter-content">
        <div className="filter-container">
          <h3>Filter & Search Backlinks</h3>
          <div className="activity-dropdown-items">
            <div className="activity-dropdown-item">
              <label htmlFor="select_account">Select account</label>
              <select
                id="select_account"
                onChange={handleSitesFilterBasedOnAccount}
                value={filter.account || "novalue"}
              >
                <option value="novalue">Select account</option>
                {allAccouts.map((account) => (
                  <option key={account.id} value={account.id}>
                    {account.searchconsoleemail}
                  </option>
                ))}
              </select>
            </div>
            <div className="activity-dropdown-item">
              <label htmlFor="select_site">Select site</label>
              <select
                id="select_site"
                onChange={handleSiteFilter}
                value={filter.site || "novalue"}
              >
                <option value="novalue">Select site</option>
                {sitesThatAreRelatedToAccount?.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.site_in_console}
                  </option>
                ))}{" "}
                {!sitesThatAreRelatedToAccount?.length &&
                  allSites?.map((site) => (
                    <option key={site.id} value={site.id}>
                      {site.site_in_console}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="search-container">
            <label htmlFor="search-element">Search</label>
            <input
              type="text"
              id="search-element"
              placeholder="Search a link"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="current_page" key={page + "numberofpageInshow"}>
        <div className="calculation">
          {
            <div className="calculation-text">
              Showing <span> {page * size - size + 1} </span> to{" "}
              <span> {page * size - size + activityLogs.length} </span> of{" "}
              <span> {total} </span> entries
            </div>
          }
        </div>
        <span
          className="current_page_left"
          onClick={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="14"
            viewBox="0 0 448 512"
            fill={page === 1 ? "grey" : "white"}
          >
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
          </svg>
        </span>
        <div className="current_page_number">{page}</div>
        <span
          className="current_page_right"
          onClick={() => {
            if (page < Math.ceil(total / size)) {
              setPage(page + 1);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="14"
            viewBox="0 0 448 512"
            fill={page === Math.ceil(total / size) ? "grey" : "white"}
          >
            <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
          </svg>
        </span>
      </div>
      <div className="table-data">
        <table className="acti-table-container">
          <thead className="acti-thead">
            <tr>
              <th className="acti-th">Action</th>
              <th className="acti-th">GSC Account</th>
              <th className="acti-th">GSC Site</th>
              <th className="acti-th acti-th-message" colSpan={2}>
                Message
              </th>
              {/* <th className="acti-th">Message</th> */}
              <th className="acti-th">Status</th>
              <th className="acti-th">Time ( in GMT )</th>
            </tr>
          </thead>
          {loading ? (
            <tbody>
              <tr>
                <td colSpan={7} className="no-data">
                  <TipLoader product={product} />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {activityLogs?.map((item) => (
                <tr key={item.id + "activityLogs"}>
                  <td className="acti-td">
                    <span className="activity-action">{item.action}</span>
                  </td>
                  <td className="acti-td">
                    <span className="account-name">
                      <span className="acti-tooltip">
                        {item.searchconsoleemail}
                      </span>
                      <span className="upperCaseName">
                        {item.searchconsoleemail
                          ? item.searchconsoleemail[0].toUpperCase()
                          : "-"}
                      </span>
                    </span>
                  </td>
                  <td className="acti-td acti-td-name">
                    <span className="site-name">
                      {item.site_url && (
                        <img
                          src={`https://www.google.com/s2/favicons?domain=${URLCleaning(
                            item.site_url,
                          )}`}
                          alt=""
                        />
                      )}
                      {URLCleaning(item.site_url)}
                    </span>
                  </td>
                  <td className="acti-td" colSpan={2}>
                    <span className="message">{item.message}</span>
                  </td>
                  <td className="acti-td">
                    <span className="acti-status">
                      {item.status === "pass" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          width="16"
                          viewBox="0 0 512 512"
                          fill="green"
                        >
                          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                        </svg>
                      ) : item.status === "fail" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          width="16"
                          viewBox="0 0 512 512"
                          fill="red"
                        >
                          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="16"
                          width="16"
                          viewBox="0 0 512 512"
                          fill="grey"
                        >
                          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                        </svg>
                      )}
                    </span>
                  </td>
                  <td className="acti-td">
                    {<span className="time">{datetime(item.create_date)}</span>}
                  </td>
                </tr>
              ))}
              {activityLogs.length === 0 && (
                <tr>
                  <td colSpan={7} className="no-data">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          )}{" "}
        </table>
      </div>
    </div>
  );
};

export default ActivityLogs;
